import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { CiamAuthService, SUPPORT_RAIL_KEY } from './ciam-auth.service';

@Injectable({ providedIn: 'root' })
export class SupportPrincipalService {
  private msal = inject(MsalService);
  private ciam = inject(CiamAuthService);

  /** Signed in when EITHER rail has an active account (workforce/staff or CIAM/partner). */
  isSignedIn(): boolean {
    return this.msal.instance.getActiveAccount() !== null || this.ciam.isSignedIn();
  }

  /** Email of the active account, preferring the rail named in sessionStorage. */
  accountEmail(): string | null {
    if (sessionStorage.getItem(SUPPORT_RAIL_KEY) === 'partner') {
      return this.ciam.getActiveAccount()?.username ?? null;
    }
    return this.msal.instance.getActiveAccount()?.username ?? null;
  }

  /** Full sign-out via the redirect flow, on whichever rail is active. Each rail clears
   * its own token cache and navigates to its own tenant's logout page. */
  signOut(): void {
    if (sessionStorage.getItem(SUPPORT_RAIL_KEY) === 'partner' && this.ciam.isSignedIn()) {
      this.ciam.signOut();
      return;
    }
    this.msal.logoutRedirect();
  }
}
